import Vue from "vue";
import { PermissionService } from "@/services/permission.service";

Vue.directive("permission", function(el, binding, vnode) {
    var permissionRequire = binding.value;
    var userPermission = PermissionService.getPermission();
    
    if (permissionRequire) {
        if (userPermission && !userPermission.includes(permissionRequire)) {
            el.style.display = "none";
        }
    }
});


// WEBPACK FOOTER //
// ./src/directives/SystemPermissionDirective.js